import type { ClientAddress } from '@DigitaleDoerfer/digitale-doerfer-api';

export const getLocationDefinition = (address?: ClientAddress) =>
  address
    ? {
        gpsLocation: address.gpsLocation,
        addressCity: address.city,
        addressStreet: address.street,
        addressZip: address.zip,
        locationName: address.name
      }
    : undefined;
